/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-1",
    "aws_appsync_graphqlEndpoint": "https://a54yylanpbg4flsrpa3ild53p4.appsync-api.eu-west-1.amazonaws.com/graphql",
    "aws_appsync_region": "eu-west-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": "da2-vdsep4h6ivg7ressqur66j7pae",
    "aws_cognito_identity_pool_id": "eu-west-1:d15cb149-356c-4a45-8566-a784f3acf62d",
    "aws_cognito_region": "eu-west-1",
    "aws_user_pools_id": "eu-west-1_nda3KVS6a",
    "aws_user_pools_web_client_id": "7smecpteugg9deqgr8ku7acg8r",
    "oauth": {}
};


export default awsmobile;
